import React, {useEffect, useState} from "react";
import Transaction, {TransactionType} from "../models/Transaction";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import RequestUtils from "../utils/RequestUtils";
import {
    Card, CardContent,
    CircularProgress,
    createStyles,
    makeStyles,
    TableFooter,
    TablePagination,
    Theme, Typography,
    withStyles
} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import {grey} from "@material-ui/core/colors";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import DateUtils from "../utils/DateUtils";
import TablePaginationActions from "../views/TablePaginationActions";
import GenUtils from "../utils/GenUtils";

// noinspection JSUnusedLocalSymbols,DuplicatedCode
export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: AppColors.CARD_SECTION_HEADER_COLORS,
            color: grey[400],
            fontWeight: 600,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 0,
            borderTopLeftRadius: 5,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 5,
            paddingRight: 5,
            border: `1px solid ${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 20)}`
        },
        body: {
            fontSize: 15,
            paddingTop: 20,
            paddingBottom: 20,
            fontWeight: 600,
            color: grey[300],
            paddingRight: 10,
            border: 'none'
        },
    }),
)(TableCell);

// noinspection JSUnusedLocalSymbols
const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: AppColors.CARD_INPUT_FIELDS,
            cursor: 'pointer',
            '&:nth-of-type(odd)': {
                backgroundColor: AppColors.lightenOrDarken(AppColors.CARD_INPUT_FIELDS, 10),
            },
            '&:hover': {
                backgroundColor: AppColors.lightenOrDarken(AppColors.CARD_INPUT_FIELDS, 30),
            }
        },
    }),
)(TableRow);


// noinspection JSUnusedLocalSymbols
const useStyles = makeStyles((theme) => ({
    checkbox: {
        color: AppColors.GREY_TEXT,
        '&.Mui-checked': {
            color: AppColors.ACCENT_COLOR
        }
    },
    checkBoxLabel: {
        fontSize: 15,
        color: AppColors.GREY_TEXT
    },
    select: {
        color: grey[400]
    }
}));

export default function Transactions() {

    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [fetchingTransactions, setFetchingTransactions] = useState(false);
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const loaded = false;
    const emptyRows = GenUtils.computeEmptyRows(rowsPerPage, transactions, page);

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    const fetchUserTransactions = () => {
        // noinspection JSUnusedLocalSymbols
        setFetchingTransactions(true);
        axios.get(EndPoints.FETCH_MY_TRANSACTIONS, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let transactions = response["data"]["data"]
            setTransactions(transactions);
            setFetchingTransactions(false);
        }).catch(_error => {
            setFetchingTransactions(false);
        });
    }

    useEffect(() => {
        fetchUserTransactions();
    }, [loaded]);

    const SimpleTableRow = React.forwardRef(function (props: any, ref: any) {
        const row = props.row;
        console.log(row);
        return <StyledTableRow>
            <StyledTableCell align="center">
                {row.transactionId.substring(row.transactionId.length / 2)}
            </StyledTableCell>
            <StyledTableCell align="center">
                {row.amount}
            </StyledTableCell>
            <StyledTableCell
                align="center">{row.transactionType}</StyledTableCell>
            <StyledTableCell align="center">{row.fee}</StyledTableCell>
            <StyledTableCell
                align="center">{DateUtils.getElapsedTime(row.createdAt)}</StyledTableCell>
        </StyledTableRow>
    });

    return <div style={{
        marginTop: 40,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '10%',
        marginRight: '10%'
    }}>
        <img src={require('../images/bitcoin_for_all.png')} style={{
            alignSelf: 'center',
        }} alt={"Free Bitcoin Icon"}/>
        {
            fetchingTransactions &&
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '45vh',
                justifyContent: 'center'
            }}>
                <CircularProgress style={{color: 'white'}}/>
                <Typography style={{color: 'white'}}>Please wait...</Typography>
            </div>
        }
        {
            transactions.length == 0 && !fetchingTransactions &&
            <Typography style={{
                height: '100vh',
                textAlign: 'center',
                color: 'white',
                paddingTop: '20vh',
            }} align={"center"}>You have not performed any transaction yet</Typography>
        }
        {
            transactions.length > 0 && !fetchingTransactions &&
            <Card
                style={{
                    width: '98%',
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 10,
                    backgroundColor: AppColors.CARD_BACKGROUND_COLOR
                }}>
                <CardContent>
                    <TableContainer>
                        <Table aria-label="stats-table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">TRX ID</StyledTableCell>
                                    <StyledTableCell align="center">AMOUNT</StyledTableCell>
                                    <StyledTableCell align="center">TYPE</StyledTableCell>
                                    <StyledTableCell align="center">FEE</StyledTableCell>
                                    <StyledTableCell align="center">DATE</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (rowsPerPage > 0 ? transactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : transactions
                                    ).map((row: Transaction, index: number) => (
                                        <SimpleTableRow row={row} key={row.id} inTransaction={true} position={index}/>
                                    ))}
                                {
                                    emptyRows > 0 && (
                                        <TableRow style={{height: 53 * emptyRows}}>
                                            <TableCell colSpan={6}/>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        style={{
                                            border: 'none',
                                            color: grey[400],
                                        }}
                                        classes={{
                                            selectIcon: classes.select
                                        }}
                                        rowsPerPageOptions={[10, 20, 30, {label: 'All', value: -1}]}
                                        colSpan={6}
                                        count={transactions.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            inputProps: {'aria-label': 'rows per page'},
                                            native: true,
                                        }}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        }
    </div>
}